import { render, staticRenderFns } from "./dap-projects.page.vue?vue&type=template&id=2a0bcf95&scoped=true"
import script from "./dap-projects.page.vue?vue&type=script&lang=ts"
export * from "./dap-projects.page.vue?vue&type=script&lang=ts"
import style0 from "./dap-projects.page.vue?vue&type=style&index=0&id=2a0bcf95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0bcf95",
  null
  
)

export default component.exports